<template>
  <div class="search-criteria-box">
    <h4 class="tit-search-type is-bgc-red400">形式</h4>
    <!-- <img src="/images/cmn/ico-format.png" class="img-fluid mx-auto" alt="" width="300" height="200"> -->
    <div class="search-radio-set" style="line-height:1.2;">
      <template v-for="option in options">
        <input type="radio"
        :name="name"
        :id="`label6-${option.id}`"
        :key="`radio6-${option.id}`"
        :value="option.data"
        @change="updateValue(option.data, option.calc)"
        >
        <label :key="`label6-${option.id}`" :for="`label6-${option.id}`" v-html="option.value"></label>
    </template>
      <small style="color:red;">※連結タイプだけでは組立できません。<br><a href="/caution.html" class="link-color" target="_blank">&raquo;詳細をご確認</a></small>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {},
    options: { type: Array },
    name: { type: String },
  },
  methods: {
    updateValue: function(value, calc) {
      this.$emit('FormatCalc', calc);
      this.$emit("input", value);
    }
  }
}
</script>